module.exports = __webpack_public_path__ + "static/media/achievement-blast-from-the-past.62f70a25.svg";